import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage';
import 'rxjs/add/operator/do';
import { environment } from '../../environments/environment';
import { MobileAppService } from '../../services/mobile-app';
import { Events, App } from 'ionic-angular';
import { BillingPaymentsProvider } from '../billing-payments/billing-payments';
import { ToastProvider } from '../toast/toast';
import{ComplaintsProvider} from'../complaints/complaints'
import { NetworkServices } from '../../services/network-services';
import { InAppBrowser, InAppBrowserOptions, InAppBrowserObject } from '@ionic-native/in-app-browser';
import { SQLite, SQLiteObject } from '@ionic-native/sqlite/ngx';
@Injectable(
  {
    providedIn: 'root'
  }
)
export class LoginProvider {
  FormURL =environment.formUrl
  URL = environment.ismUrl;
  data: any;
  societyLogo:null;
  // private database: SQLiteObject

  constructor(private http: HttpClient, 
    private storage: Storage, 
    private appService: MobileAppService,
    private event: Events,
    private bpProvider: BillingPaymentsProvider,
    private toast: ToastProvider,
    private networkServices: NetworkServices,
    private app: App,
    private complaintprovider:ComplaintsProvider,
    private inAppBrowser:InAppBrowser,
    private sqlite: SQLite,
   
    ) {
      
      this.getAssociatedUnits();
      
  }
  openDatabase() {
    return window['sqlitePlugin'].openDatabase({
      name: 'ism.db',
      location: 'default'
    });
  }
  
  initializeDatabase(data) {
    console.log("initializeDatabase function called"); 
  
    const performDatabaseOperations = (db, data) => {
      db.executeSql('CREATE TABLE IF NOT EXISTS people(id INTEGER PRIMARY KEY, value TEXT)', [],
        (res) => {
          console.log('Table created');
          
          // Read the table where id = 1
          db.executeSql('SELECT value FROM people WHERE id = 1', [],
            (res) => {
              if (res.rows.length > 0) {
                // If there's a result, update the value for that id 1
                console.log('Record exists, updating...');
                db.executeSql('UPDATE people SET value = ? WHERE id = 1', [data],
                  (res) => {
                    console.log('Record updated successfully');
                  },
                  (error) => {
                    console.error('Error updating record', error);
                  }
                );
              } else {
                // If no result, insert value to id 1
                console.log('Record does not exist, inserting...');
                db.executeSql('INSERT INTO people (id, value) VALUES (1, ?)', [data],
                  (res) => {
                    console.log('Record inserted successfully');
                  },
                  (error) => {
                    console.error('Error inserting record', error);
                  }
                );
              }
            },
            (error) => {
              console.error('Error selecting record', error);
            }
          );
        },
        (error) => {
          console.error('Error creating table', error);
        }
      );
    };

    performDatabaseOperations(this.openDatabase(),data)

  
    // if (!this.database) {
    //   console.log("Database is not present, opening...");
    //   this.openDatabase()
    //     .then((db) => {
    //       this.database = db; // Store database connection
    //       return performDatabaseOperations(db);
    //     })
    //     .catch(e => {
    //       console.error('Error opening database', e);
    //     });
    // } else {
    //   console.log("Database is already open, proceeding with operations...");
    //   performDatabaseOperations(this.database);
    // }
  }
 
  

  
  login(params: any){
    if(environment.debug) console.log("Enter login(param) ==>", new Date());
    return this.http.post<Response>(this.URL+'/login',params)
    .do(res => {
      if(environment.debug) console.log("Login response=>", res, new Date());
      
    });
  }
  isLogin(){
    return this.storage.get("loginDetails").then((val) => {
  
      if(environment.debug) console.log("Enter isLogin() value=>", val, new Date());
      if(val){
        if(environment.debug) console.log("Enter isLogin() value found=>", new Date());
        this.updateUserRegisterApp(val);

        return true;
      }
      else { 
        let data = localStorage.getItem("loggedinUserIndex");
        if(data){
          let dataObj = JSON.parse(data);
          if(environment.debug) console.log("localStorage.getItem(loggedinUserIndex) value=>", dataObj, new Date());
          if(environment.allowRole.indexOf(dataObj.role) != -1){
            this.storage.set("loginDetails", dataObj).then(val => {
              if(environment.debug) console.log("storage.set(loginDetails) dataObj, val=>", dataObj, val, new Date());
              this.updateUserRegisterApp(dataObj);
            });
            return true;
          }else{
            if(environment.debug) console.log("isLogin() role not found=>", new Date());
            return false;
          }
        }else{
          if(environment.debug) console.log("localStorage.getItem(loggedinUserIndex) not found=>", new Date());
          return false;
        }
      }
    });
  }

  updateUserRegisterApp(val){
  
    console.log("Enter into updateUserRegisterApp ===>");    
    var ttt = !val.tenant || val.tenant == 0 || typeof val.tenant === 'undefined' || val.tenant == 'undefined' || val.tenant == false ? 0 : 1;
    return this.http.get<any>(`${this.URL}/getUserProfileData?api-token=${val.api_token}&user-id=${val.id}&tenant=${ttt}`)
    .toPromise().then((res: Response) => {
      if(res.status == "success"){
     
        console.log("Success response for getUserProfileData  ===> ");
        this.storage.set("loginDetails", res.data);
        localStorage.setItem("loggedinUserIndex", JSON.stringify(res.data))
        this.setSocietySettings(res.data);

        
        if(environment.runAs == environment.constant.APP) {
          this.appService.registerApp();
        this.initializeDatabase(JSON.stringify(res.data));        this.event.publish('user:created', res.data);
        }
      }else if(res.status == "error"){
        this.logOut();
        this.app.getRootNav().push("HomePage");
      }
      

    }).catch(e => {
      console.log(e)
      this.toast.presentToast("Unable to update user info!");
    });
  }

  // updateUserDetails(){
  //   return this.storage.get("loginDetails").then((val) => {
  //     if(val){
  //       var ttt = !val.tenant || val.tenant == 0 || typeof val.tenant === 'undefined' || val.tenant == 'undefined' || val.tenant == false ? 0 : 1;
  //       this.http.get<any>(`${this.URL}/getUserProfileData?api-token=${val.api_token}&user-id=${val.id}&tenant=${ttt}`)
  //       .toPromise().then((res: Response) => {
  //         if(res.status == "success"){
  //           this.storage.set("loginDetails", res.data);
  //           localStorage.setItem("loggedinUserIndex", JSON.stringify(res.data))
  //           this.event.publish('user:created', res.data);
  //           return true;
  //         }else{
  //           this.toast.presentToast("Unable to update user.");
  //         }
  //       });
  //     }
  //   });
  // }

  setSocietySettings(val){
    this.http.get<any>(`${this.URL}/my/societyconfig?api-token=${val.api_token}&user-id=${val.id}`)
    .toPromise().then(res => {
      if(res.status == "success" && (res.data)){
        this.storage.set("societyConfig", res.data);
         console.log(res.data)
        return true;
      }else{
        this.storage.remove("societyConfig");
      }
    }).catch(val => {
    this.storage.remove("societyConfig");
      console.log("not able to get society config");
    });
  }

  getSocietySettings(){
    return this.storage.get("societyConfig");
  }
  async getSocietyLogo() {
    const val = await this.storage.get("societyConfig");
    if (val) {
  
      const data = JSON.parse(val['society_data'].data);
      if (data && data.logo && data.logo !== '') {
        this.societyLogo = data.logo;
        console.log(this.societyLogo, 'society logo');
        return this.societyLogo; // Return the logo
      }
    }
    return null; // Return null if no logo is found
  }
  

  getMeterUser(){
    return this.getToken().then((val) => {
      if(val){
        return this.http.get<Response>(this.getUrl(`/my/meteruser`,val))
        .toPromise();
      }
    });
  }

  sendOtp(params: any){
    // console.log(params);
    return this.http.post<Response>(this.URL+'/generateotp',params)
    .do(res => console.log(res));
  }

  logintokenuser(site, token){
    console.log({site, token});
    return this.http.post<Response>(this.URL+'/logintokenuser',{site:site,token:token})
    .toPromise();
  }
  verifyOtp(params: any){
      console.log("verifyOtp=>",params);
    return this.http.post<Response>(this.URL+'/validateotp',params)
    .do(res => console.log(res));
  }

  resendOtp(params: any){
    console.log("resendOtp =>",params);
    return this.http.post<Response>(this.URL+'/resendotp',params)
    .do(res => console.log(res));
  }

  loadAccount(token: any){
    return this.http.get<Response>(`${this.URL}/getmyaccounts?token=${token}`)
    .do(res => console.log(res));
  }

  otpLogin(params: any, token: string){
    return this.http.post<Response>(this.URL+'/logmein?token='+token,params)
    .do(res => console.log(res));
  }

  profileDetails(){
    return this.storage.get("profileData").then(val => {
      // if(val){
      //   return Promise.resolve(this.storage.get("profileData"));
      // }else{
        return this.getToken().then((val) => {
          if(val){
            return this.http.get<any>(this.getUrl(`/userDetailsById/${val.id}`,val))
            .toPromise().then(val => {
              if(!(val.status && val.status == "error")){
                this.storage.set("profileData", val);
              }
              //this.event.publish('user:created', val);
              return val;
            });
          }
        });
      // }
    });
  }

  userParkingDetails(){
    return this.getToken().then((val) => {
      if(val){
        return this.http.get<Response>(this.getUrl(`/getParkingByFlatno/${val.flat_no}`,val))
        .toPromise();
      }
    });
  }

  changePass(data: any){
    return this.getToken().then((val) => {
      if(val.tenant == '1'){
        return this.http.post<Response>(this.getUrl(`/v1/changetenantpassword`,val), data)
        .toPromise();
      }else{
        return this.http.post<Response>(this.getUrl(`/v1/changePassword`,val), data)
        .toPromise();
      }
    });
  }

  fpGenerateOtp(phone: string){
    return this.http.post<any>(`${this.URL}/otpGen`, {
      phone
    })
    .toPromise();
  }

  fpVerifyOtp(hash: string, id: number, otp: number){
    return this.http.post<any>(`${this.URL}/otpVal`, {
      hash,
      id,
      otp
    })
    .toPromise();
  }

  resetPassword(id: number, token: string, password: string){
    return this.http.post<any>(`${this.URL}/chpwd`, {
      id,
      token,
      password
    })
    .toPromise();
  }

  changeProfilePicture(image: string){
    return this.getToken().then((val) => {
      if(val){
        return this.http.post<Response>(this.getUrl(`/addPhoto`,val), {
          file: image,
          societyId: val.societyId,
          userId: val.id
        }).toPromise().then(val => {
          this.storage.remove("profileData");
          return val;
        });
      }
    });
  }

  sendTenantPassword(username){
    return this.http.post<any>(`${this.URL}//sendPasswordTenant`, {
      identity: username
    })
    .toPromise();
  }

  getUserDetails(){
    return this.storage.get("loginDetails");
  }
  getAssociatedUnits(){
    console.log("getAssociatedUnits")
   this.complaintprovider.getAssociatedUnits().then(val => {
        if(val && val.unit_nos){
      this.storage.set("associatedUnits",val.unit_nos);
        }

    })
  }

  logOut(): void {
    if(environment.debug) console.log("Enter logOut() =>", this.storage.get("loginDetails"));
    MobileAppService.islogout = 1;
    this.appService.unRegisteredApp();
    this.storage.remove("profileData");
    this.storage.remove("loginDetails");
    this.storage.remove("allCategories");
    this.storage.remove("societyConfig");
    localStorage.removeItem("loggedinUserIndex");
    this.storage.clear();
    localStorage.clear();
    this.bpProvider.billTypesMap.clear();
    localStorage.setItem('skip_tutorial','true' );  
    if(environment.debug) console.log("Exit logOut() =>", this.storage.get("loginDetails"));
  }

  getCovidDetails(){
    return this.getToken().then((val) => {
      if(val){
        return this.http.get<Response>(this.getUrl(`/whatisnew`,val))
        .toPromise();
      }
    });
  }

  getToken(){
    return this.storage.get("loginDetails");
  }

  openWithInAppBrowser(url : string){
    let options : InAppBrowserOptions = {
      hidenavigationbuttons : 'yes',
      footer : 'yes',
      location : 'no',//Or 'no' 
      hidden : 'no', //Or  'yes'
      clearcache : 'yes',
      clearsessioncache : 'yes',
      zoom : 'no',//Android only ,shows browser zoom controls 
      hardwareback : 'no',
      mediaPlaybackRequiresUserAction : 'no',
      shouldPauseOnSuspend : 'no', //Android only 
      closebuttoncaption : 'Done', //iOS only
      disallowoverscroll : 'no', //iOS only 
      toolbar : 'yes', //iOS only 
      enableViewportScale : 'no', //iOS only 
      allowInlineMediaPlayback : 'no',//iOS only 
      presentationstyle : 'pagesheet',//iOS only 
      fullscreen : 'yes',//Windows only  
    };
    let target = "_blank";
    var obj1 = this.inAppBrowser.create(url,target,options);
    obj1.on('exit').subscribe( (obj)=>{
      try{
        this.event.publish('Feature:exit', obj);
      }catch(e){
        console.log(e);
      }
    })
  }
  
  addReferral(data){
	  return this.getToken().then((val) => {
      if(val){
        return this.http.post<Response>(this.getUrl(`/society/${val.societyId}/my/referral`,val),data
          ).toPromise();
      }
    });
  }

  getReferral(userId){
    return this.getToken().then((val) => {
      if(val){
        return this.http.get<Response>(this.getUrl(`/society/${val.societyId}/my/referral`,val)+`${`&user-id=`+userId}`).toPromise();
      }
    });
  }

  getUrl(link: string, val: any):string {
    return `${this.URL}${link}?api-token=${val.api_token}&user-id=${val.id}`;
  }
  getFormUrl(link: string, val: any):string {
    return `${this.FormURL}${link}?api-token=${val.api_token}&user-id=${val.id}`;
  }
  getUserUpdateForm(){
    return this.getToken().then((val) => {
      if(val){
        return this.http.get<Response>(this.getFormUrl(`/v2/society/${val.societyId}/form`,val)+ `${`&type=USER_REGISTRATION &default=1`}`).toPromise();
            
      }
    });

  }
}

export class Response{
  constructor(res){
    // console.log(res);
  }
  status: string;
  message: string;
  data?: any;
  metadata?: any;
}


// WEBPACK FOOTER //
// ./src/providers/login/login.ts